import { CountryCode } from '@crehana/ts-types';

export const HOMEPAGE_AMPLITUDE_PAGE_NAME = 'Homepage';
export const HOMEPAGE_PAGE_KEY = 'home';

export const SEO_DEFAULTS = {
  og_data: {
    type: 'crehana:product',
    site_name: 'Crehana',
    image: {
      url: 'https://crehana-vercel-images-prd.imgix.net/public/3e3bc233-d947-4481-9119-50b2d2303205-homepage-seo.jpeg?auto=format&fit=clip',
      alt: 'Crehana',
    },
  },
};

export const SEO_TEMPORAL_FIX = {
  pe: {
    metaTitle:
      'Black Days Crehana: +1000 cursos certificados con hasta 40% de descuento',
    metaDescription:
      'Certificate, alcanza tus objetivos y mejora tus habilidades con nuestros packs de cursos con hasta 40% de descuento. ¡Aprende hoy y aplica hoy!',
  },
  co: {
    metaTitle:
      'Crehana en Black Days: +1000 cursos certificados con hasta 40% off',
    metaDescription:
      'Certificate, alcanza tus objetivos y mejora tus habilidades con nuestros packs de cursos con hasta 40% de descuento. ¡Aprende hoy y aplica hoy!',
  },
  mx: {
    metaTitle: 'Buen Fin Crehana: +1000 cursos con descuentos de hasta el 75%',
    metaDescription:
      'Alcanza tus objetivos y mejora tu CV con nuestros más de 1000 cursos certificados. Packs, membresías, especializaciones con descuentos de hasta el 75%',
  },
  ar: {
    metaTitle: 'Crehana: Cursos con hasta 40% off para aprender a tu ritmo',
    metaDescription:
      'Cursos online certificados para potenciar tu crecimiento y mejorar tu CV. Más de 1000 cursos con hasta el 40% off para aprender online. ¡Aprendé hoy y aplicá hoy!',
  },
  es: {
    metaTitle: 'Black Days Crehana: Aprende y Certificate con +1000 cursos',
    metaDescription:
      '¡Aprende hoy y aplica hoy! Alcanza tus metas y potencia tus habilidades con +1000 cursos online certificados. Cursos con descuentos de hasta el 40%',
  },
  default: {
    metaTitle: 'Crehana: Aprende y Certificate con +1000 cursos hasta 40% OFF',
    metaDescription:
      '¡Aprende hoy y aplica hoy! Alcanza tus metas y potencia tus habilidades con +1000 cursos online certificados. Cursos con descuento de hasta el 40%.',
  },
};

export const getDefaultSeoHomepage = (
  countryCode?: CountryCode | null,
): { metaTitle: string; metaDescription: string } => {
  if (countryCode && countryCode in SEO_TEMPORAL_FIX) {
    // @ts-expect-error aleready validated
    return SEO_TEMPORAL_FIX[countryCode];
  }

  return SEO_TEMPORAL_FIX.default;
};
